package com.evoapps.evoshift.data.dto.owner

import com.evoapps.evoshift.data.dto.workplace.WorkplaceFinancialsDto
import com.evoapps.evoshift.data.dto.workplace.WorkplaceSettingsDto
import kotlinx.serialization.Serializable

/**
 * SH-269: workplaces/{id}/group_settings/current without the values: the group it points at and
 * the sections that follow it (functions/groupSettings.js writes it, the managers read it).
 */
@Serializable
data class GroupSettingsLinkDto(
    val groupId: String = "",
    val groupName: String = "",
    val isDefault: Boolean = false,
    val workplaceCount: Int = 0,
    val inheritedSections: List<String> = emptyList()
)

/**
 * SH-269: the group's values, in the same layout as a workplace's settings and financials/data
 * (on the link and on workplace_groups/{id}). Read on their own: a value the app cannot read leaves
 * the link usable.
 */
@Serializable
data class GroupSettingsValuesDto(
    val settings: WorkplaceSettingsDto? = null,
    val financials: WorkplaceFinancialsDto? = null
)
